import { dateRange, isConnected } from '../state';
import { fetchAnalyticsData } from './fetchAnalyticsData';

/**
 * Tarih aralığı değişikliğini takip et
 * @param {string} assetId - Asset ID
 */
export function handleDateRangeChange(assetId) {
  // Tarih aralığı değiştiğinde veriyi yeniden getir
  // Bu fonksiyon watch hook'una bağlanacak
  if (dateRange.value.start && dateRange.value.end && isConnected.value) {
    fetchAnalyticsData(assetId);
  }
}